import { db, storage } from './firebase'; 
import { collection, addDoc, getDocs, deleteDoc, updateDoc, doc } from "firebase/firestore";
import { auth } from './firebase'; 
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; 
import { onAuthStateChanged, signOut, signInWithEmailAndPassword } from "firebase/auth";
import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = 'pk.eyJ1IjoibWFyY2lubXJvIiwiYSI6ImNtbnd6dXhsNDAwNjcyb3FwYmtkNmVxNWIifQ.SonFr49i2FrBUJUPtMb9LQ';

function App() {
  const [stats, setStats] = useState({ total: 0, przy_drodze: 0, na_budynku: 0, na_drzewie: 0, inna: 0 });
  const mapContainer = useRef(null);
  const map = useRef(null);
  const pressTimer = useRef(null); // Timer dla funkcji Long Press

  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // --- SEKCJA 1: GLOBALNA OBSŁUGA KLIKNIĘĆ (EDYCJA I USUWANIE) ---
  useEffect(() => {
    const handleGlobalClick = async (e) => {
      const target = e.target;
      
      // USUWANIE
      if (target.id && target.id.startsWith('delete-btn-')) {
        const dId = target.dataset.displayid;
        if (window.confirm(`Czy na pewno usunąć obiekt: ${dId}?`)) {
          try {
            const snapshot = await getDocs(collection(db, "kapliczki"));
            snapshot.forEach(async (docRef) => {
              if (docRef.data().displayId === dId) {
                await deleteDoc(doc(db, "kapliczki", docRef.id));
                alert("Usunięto pomyślnie!");
                window.location.reload();
              }
            });
          } catch (err) { alert("Błąd usuwania: " + err.message); }
        }
      }

      // EDYCJA (OTWARCIE FORMULARZA + CENTROWANIE)
      if (target.id && target.id.startsWith('edit-btn-')) {
        const idSafe = target.id.replace('edit-btn-', '');
        const dId = target.dataset.displayid;
        const container = document.getElementById(`popup-content-${idSafe}`);
        const currentName = container.querySelector('h3').innerText;

        // Centrowanie mapy przy edycji, by widzieć formularz na mobile
        map.current.flyTo({
          center: [parseFloat(target.dataset.lng), parseFloat(target.dataset.lat)],
          offset: [0, 150], // Przesunięcie punktu w górę ekranu
          zoom: 16,
          essential: true
        });

        container.innerHTML = `
          <div style="padding: 5px;">
            <h4 style="margin: 0 0 10px 0;">Edytuj obiekt</h4>
            <label style="font-size: 11px; color: #666; display: block; margin-bottom: 2px;">Dodaj nazwę</label>
            <input type="text" id="edit-input-name-${idSafe}" value="${currentName}" style="width: 100%; margin-bottom: 5px; padding: 5px; box-sizing: border-box;"/>
            <label style="font-size: 11px; color: #666; display: block; margin-bottom: 2px;">Wybierz kategorię</label>
            <select id="edit-input-cat-${idSafe}" style="width: 100%; margin-bottom: 10px; padding: 5px; width: 100%;">
              <option value="przy_drodze">🛣️ Przy drodze</option>
              <option value="na_budynku">🏫 Na budynku</option>
              <option value="na_drzewie">🌳 Na drzewie</option>
              <option value="inna">⛪ Inna</option>
            </select>
            <button id="save-edit-final-${idSafe}" data-displayid="${dId}" style="width: 100%; background: #3b82f6; color: white; border: none; padding: 10px; cursor: pointer; border-radius: 4px; font-weight: bold;">Zapisz zmiany</button>
          </div>
        `;
      }

      // ZAPIS EDYCJI
      if (target.id && target.id.startsWith('save-edit-final-')) {
        const idSafe = target.id.replace('save-edit-final-', '');
        const dId = target.dataset.displayid;
        const newName = document.getElementById(`edit-input-name-${idSafe}`).value;
        const newCat = document.getElementById(`edit-input-cat-${idSafe}`).value;

        try {
          const snapshot = await getDocs(collection(db, "kapliczki"));
          snapshot.forEach(async (docRef) => {
            if (docRef.data().displayId === dId) {
              await updateDoc(doc(db, "kapliczki", docRef.id), {
                name: newName,
                category: newCat
              });
              alert("Zaktualizowano!");
              window.location.reload();
            }
          });
        } catch (err) { alert("Błąd edycji: " + err.message); }
      }
    };

    document.addEventListener('click', handleGlobalClick);
    return () => document.removeEventListener('click', handleGlobalClick);
  }, []);

  // --- SEKCJA 2: FUNKCJA TWORZĄCA MARKER ---
  const createMarker = (lng, lat, name, category, displayId, imageUrl) => {
    if (!map.current) return;

    const el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png)';
    el.style.width = '25px';
    el.style.height = '41px';
    el.style.backgroundSize = '100%';
    el.style.cursor = 'pointer';

    let hoverPopup = new mapboxgl.Popup({ closeButton: false, closeOnClick: false, offset: 25 });

    el.addEventListener('mouseenter', () => {
      const title = name ? name : displayId;
      const imgHtml = imageUrl 
        ? `<img src="${imageUrl}" style="width: 120px; height: 80px; object-fit: cover; border-radius: 4px; display: block; margin-bottom: 5px;">` 
        : '<div style="font-size:10px; color:gray; margin-bottom:5px;">Brak zdjęcia</div>';
      hoverPopup.setLngLat([lng, lat]).setHTML(`<div style="text-align: center; padding: 2px;">${imgHtml}<b>${title}</b></div>`).addTo(map.current);
    });

    el.addEventListener('mouseleave', () => hoverPopup.remove());

    el.addEventListener('click', (e) => {
      e.stopPropagation(); 
      if (hoverPopup) hoverPopup.remove();

      const idSafe = (displayId || '').replace('#', '').replace(/\s/g, '');
      const title = name ? name : displayId;
      const fullImgHtml = imageUrl ? `<img src="${imageUrl}" style="width: 100%; max-height: 200px; object-fit: cover; border-radius: 8px; margin-top: 10px;">` : '';

      const adminButtons = auth.currentUser ? `
        <div style="display: flex; gap: 5px; margin-top: 10px;">
          <button id="edit-btn-${idSafe}" data-displayid="${displayId}" data-lng="${lng}" data-lat="${lat}" style="flex: 1; background: #0bd2f5; color: white; border: none; padding: 5px; cursor: pointer; border-radius: 4px; font-size: 11px;">Edytuj</button>
          <button id="delete-btn-${idSafe}" data-displayid="${displayId}" style="flex: 1; background: #ef4444; color: white; border: none; padding: 5px; cursor: pointer; border-radius: 4px; font-size: 11px;">Usuń</button>
        </div>
      ` : '';

      new mapboxgl.Popup({ offset: 25 })
        .setLngLat([lng, lat])
        .setHTML(`
          <div id="popup-content-${idSafe}" style="color: #333; padding: 5px; min-width: 220px;">
            <h3 style="margin: 0;">${title}</h3>
            <p style="margin: 8px 0 0;"><b>Kategoria:</b> ${(category || '').replace('_', ' ')}</p>
            ${fullImgHtml}
            ${adminButtons}
          </div>
        `)
        .addTo(map.current);
    });

    new mapboxgl.Marker(el).setLngLat([lng, lat]).addTo(map.current);
  };

  // --- SEKCJA 3: START MAPY I FIREBASE ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => setUser(currentUser));

    const startMap = (coords, zoomLevel) => {
      if (!mapContainer.current || map.current) return;
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: coords,
        zoom: zoomLevel
      });

      // OBSŁUGA LONG PRESS (Mysz i Dotyk)
      map.current.on('mousedown', (e) => {
        if (!auth.currentUser) return;
        pressTimer.current = setTimeout(() => showAddForm(e.lngLat), 800);
      });
      map.current.on('mouseup', () => clearTimeout(pressTimer.current));
      map.current.on('mousemove', () => clearTimeout(pressTimer.current));

      map.current.on('touchstart', (e) => {
        if (!auth.currentUser) return;
        pressTimer.current = setTimeout(() => showAddForm(e.lngLat), 800);
      });
      map.current.on('touchend', () => clearTimeout(pressTimer.current));
      map.current.on('touchmove', () => clearTimeout(pressTimer.current));

      const showAddForm = (lngLat) => {
        const { lng, lat } = lngLat;
        
        // Centrowanie mapy, by formularz był nad klawiaturą
        map.current.flyTo({ center: [lng, lat], offset: [0, 150], zoom: 16 });

        const popupContent = document.createElement('div');
        popupContent.innerHTML = `
          <div style="color: #333; padding: 5px; min-width: 180px;">
            <h3 style="margin: 0 0 10px 0; font-size: 14px;">Dodaj nową kapliczkę</h3>
            
            <label style="font-size: 11px; color: #666; display: block; margin-bottom: 2px;">Dodaj nazwę</label>
            <input type="text" id="obj-name" placeholder="np. patron lub ulica..." style="width: 100%; margin-bottom: 8px; padding: 5px; box-sizing: border-box;"/>
            
            <label style="font-size: 11px; color: #666; display: block; margin-bottom: 2px;">Dodaj zdjęcie</label>
            <input type="file" id="obj-image" accept="image/*" style="width: 100%; margin-bottom: 10px; font-size: 11px;"/>
            
            <label style="font-size: 11px; color: #666; display: block; margin-bottom: 2px;">Wybierz kategorię</label>
            <select id="obj-category" style="width: 100%; margin-bottom: 12px; padding: 5px; width: 100%;">
              <option value="przy_drodze">🛣️ Przy drodze</option>
              <option value="na_budynku">🏫 Na budynku</option>
              <option value="na_drzewie">🌳 Na drzewie</option>
              <option value="inna">⛪ Inna</option>
            </select>
            
            <button id="save-btn" style="background: #3b82f6; color: white; border: none; padding: 10px; cursor: pointer; width: 100%; border-radius: 4px; font-weight: bold;">Zapisz obiekt</button>
          </div>
        `;

        const popup = new mapboxgl.Popup({ offset: 25 }).setLngLat([lng, lat]).setDOMContent(popupContent).addTo(map.current);

        popupContent.querySelector('#save-btn').onclick = async () => {
          const nameValue = document.querySelector('#obj-name').value;
          const categoryValue = document.querySelector('#obj-category').value;
          const imageFile = document.querySelector('#obj-image').files[0];
          const btn = document.querySelector('#save-btn');
          btn.innerText = "Wysyłanie..."; btn.disabled = true;

          try {
            let finalImageUrl = "";
            if (imageFile) {
              const fileRef = ref(storage, `kapliczki/${Date.now()}_${imageFile.name}`);
              await uploadBytes(fileRef, imageFile);
              finalImageUrl = await getDownloadURL(fileRef);
            }
            const snapshot = await getDocs(collection(db, "kapliczki"));
            const generatedId = `Kapliczka #${snapshot.size + 1}`;
            await addDoc(collection(db, "kapliczki"), { 
              name: nameValue, 
              displayId: generatedId, 
              category: categoryValue, 
              imageUrl: finalImageUrl, 
              lng, lat, 
              timestamp: new Date() 
            });
            popup.remove();
            window.location.reload(); 
          } catch (e) { alert("Błąd zapisu."); btn.innerText = "Zapisz"; btn.disabled = false; }
        };
      };

      map.current.on('style.load', () => {
        const geolocate = new mapboxgl.GeolocateControl({ positionOptions: { enableHighAccuracy: true }, trackUserLocation: true, showUserHeading: true });
        map.current.addControl(geolocate, 'top-right');
        fetchKapliczki();
      });
    };

    const fetchKapliczki = async () => {
      const querySnapshot = await getDocs(collection(db, "kapliczki"));
      const newStats = { total: 0, przy_drodze: 0, na_budynku: 0, na_drzewie: 0, inna: 0 };
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        createMarker(data.lng, data.lat, data.name, data.category, data.displayId, data.imageUrl);
        newStats.total++;
        if (newStats.hasOwnProperty(data.category)) newStats[data.category]++;
      });
      setStats(newStats);
    };

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((pos) => startMap([pos.coords.longitude, pos.coords.latitude], 14), () => startMap([20.411836, 51.144852], 14));
    } else { startMap([20.411836, 51.144852], 15); }
    return () => unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try { await signInWithEmailAndPassword(auth, email, password); } catch (err) { alert("Błąd logowania: " + err.message); }
  };

  return (
    <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
      {/* PANEL LOGOWANIA */}
      <div style={{ position: 'absolute', top: '10px', right: '50px', zIndex: 10, background: 'white', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        {user ? (
          <div><span style={{ fontSize: '12px' }}>Zalogowany: {user.email}</span><button onClick={() => signOut(auth)} style={{ marginLeft: '10px', cursor: 'pointer' }}>Wyloguj</button></div>
        ) : (
          <form onSubmit={handleLogin} style={{ display: 'flex', gap: '5px' }}>
            <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} style={{ width: '80px' }} />
            <input type="password" placeholder="Hasło" onChange={(e) => setPassword(e.target.value)} style={{ width: '80px' }} />
            <button type="submit" style={{ cursor: 'pointer' }}>Zaloguj</button>
          </form>
        )}
      </div>

      {/* STATYSTYKI */}
      <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1, background: 'white', padding: '15px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', fontFamily: 'sans-serif' }}>
        <h3 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>📊 Statystyki</h3>
        <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
          <strong>Suma: {stats.total}</strong><br/>
          <hr style={{ margin: '8px 0', border: '0', borderTop: '1px solid #eee' }} />
          🛣️ Przy drodze: {stats.przy_drodze}<br/>
          🏫 Na budynku: {stats.na_budynku}<br/>
          🌳 Na drzewie: {stats.na_drzewie}<br/>
          ⛪ Inna: {stats.inna}
        </div>
      </div>
      <div ref={mapContainer} style={{ height: '100%' }} />
    </div>
  );
}

export default App;